
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcedureMethodDefinitionVersionParameterVersionsGraphQL"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseProcedureMethodDefinitionVersionInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataParameterSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"procedureDataParameterId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmationMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restValueField"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"materialInputSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amountUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"procedureMaterialInputId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmationMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restMaterialField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restAmountField"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"materialOutputSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"procedureMaterialOutputId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmationMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restMaterialField"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowedEquipmentModels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"procedureEquipmentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmationMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restEquipmentField"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1062}};
    doc.loc.source = {"body":"# This intentionally does not include any values on the parameters so that it can be used in execution\n# as well as config\nfragment ProcedureMethodDefinitionVersionParameterVersionsGraphQL on BaseProcedureMethodDefinitionVersionInterface {\n  dataParameterSettings {\n    version {\n      id\n      name\n      description\n      dataType\n      minimum\n      maximum\n      procedureDataParameterId\n      confirmationMethod\n      restValueField\n    }\n  }\n  materialInputSettings {\n    version {\n      id\n      name\n      description\n      dataType\n      amountUnit\n      procedureMaterialInputId\n      confirmationMethod\n      restMaterialField\n      restAmountField\n    }\n  }\n  materialOutputSettings {\n    version {\n      id\n      name\n      description\n      dataType\n      procedureMaterialOutputId\n      confirmationMethod\n      restMaterialField\n    }\n  }\n  equipmentSettings {\n    version {\n      id\n      name\n      description\n      dataType\n      allowedEquipmentModels\n      procedureEquipmentId\n      confirmationMethod\n      restEquipmentField\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProcedureMethodDefinitionVersionParameterVersionsGraphQL"] = oneQuery(doc, "ProcedureMethodDefinitionVersionParameterVersionsGraphQL");
        
